<template>
  <aside class="block overflow-hidden bg-white border rounded">
    <div class="border-b border-ricoma-gray-300 p-3 lg:p-5">
      <div class="flex justify-between">
        <div class="flex gap-3 items-center">
          <img
            class="object-contain object-center w-8 h-8"
            src="../../assets/giftcard-icon.svg"
            alt="ad"
          />
          <span class="text-sm font-bold">{{ $t('dashboard.giftcards.title') }}</span>
        </div>
        <div>
          <a href="/giftcards" style="color: #f17d21" class="text-xs lg:text-sm">
            {{ $t('dashboard.giftcards.view') }}
          </a>
        </div>
      </div>
    </div>
    <div class="p-3 lg:p-5">
      <div class="flex gap-3 items-center">
        <div>
          <img
            class="object-contain object-center w-32 h-32"
            src="../../assets/giftcard-logo.png"
            alt="ad"
          />
        </div>
        <div>
          <p class="text-base font-bold">Shop Gift Card ({{ giftcards.length }})</p>
          <p class="text-sm">
            Balance:
            <b class="text-base"
              >$ {{ giftcards.reduce((acc, cur) => acc + parseInt(cur.balance), 0) }}</b
            >
          </p>
        </div>
      </div>
      <p class="text-sm">
        {{ $t('dashboard.giftcards.text') }}
        <a
          class="font-bold text-[#F17D21]"
          target="_blank"
          style="color: #f17d21"
          href="https://ricoma.com/"
          >ricoma.com.</a
        >
      </p>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex';
import { safeNullDataset } from '@/utils';

export default {
  name: 'DashboardGiftcardsCard',
  props: {},
  components: {},
  computed: mapState({
    giftcards: state => safeNullDataset(state)(['customer', 'giftcards']),
  }),
  async mounted() {
    !this.giftcards.length && (await this.$store.dispatch('customer/getGiftcards'));
  },
};
</script>
